import { NavHashLink } from "react-router-hash-link";

export function AnchorLink(props) {
    return (
        <div
            className="z-20 h-full w-full"
            onClick={props.onClick}
        >
            <NavHashLink
                to={props.target}
                activeStyle={{ color: "#242d29" }}
                className={`flex text-left text-base items-center h-full cursor-pointer font-bold no-underline text-white px-12 py-6 hover:bg-pine !text-pine hover:!text-white ${
                    props.className ? props.className : ""
                }`}
            >
                {props.content}
            </NavHashLink>
        </div>
    );
}
